import { VStack, SimpleGrid } from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';

import LocationCard from './LocationCard';

import { ReturnContainerPointWithId } from '~/types/platform/returnContainerPoint';

import getScheduleTimeString from '~/utils/getScheduleTimeString';

export type LocationListProps = { returnContainerPoints: Array<ReturnContainerPointWithId> };

// 歸還餐盒地點全部列表
export default function LocationList({ returnContainerPoints }: LocationListProps) {
  const navigate = useNavigate();
  const handleOnClick = (id: string) => {
    navigate(`locationInfo/${id}`);
  };
  return (
    <VStack spacing={4} align="stretch">
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
        {returnContainerPoints.map(({ name, image, description, schedule, id }) => (
          <LocationCard
            key={id}
            name={name}
            image={image}
            location={description}
            time={getScheduleTimeString(schedule, [], new Date())}
            onClick={() => handleOnClick(id)}
          />
        ))}
      </SimpleGrid>
    </VStack>
  );
}
